/* eslint-disable id-blacklist */
export enum ExecutionStatus {
  Undefined = 'Undefined',
  NotCheckIn= 'NotCheckIn',
  CheckIn = 'CheckIn',
  DeliveryStarted = 'DeliveryStarted'
};
